export class ConditionReferenceModel {
    public conditionCode: string;
    public conditionName: string;
    public sortSequence: number;
    public statusCode: string;    
}
